export default function ValueBenefits() {
  const benefits = [
    {
      icon: '⏱️',
      title: 'Spar tid',
      desc: 'Automatisér manuelle processer og frigør ressourcer til det der skaber værdi.',
    },
    {
      icon: '✅',
      title: 'Færre fejl',
      desc: 'Data valideres direkte i systemet – ingen manuelle fejl, ingen dobbeltindtastning.',
    },
    {
      icon: '🔍',
      title: 'Fuld transparens',
      desc: 'Se alle dokumenter, status og historik ét sted i jeres portal.',
    },
    {
      icon: '🔗',
      title: 'Skaler nemt',
      desc: 'Tilføj flere systemer og dokumenttyper i takt med jeres behov vokser.',
    },
  ];

  return (
    <section className="py-24 px-6 md:px-12 border-b border-border relative z-10">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 reveal">
          <span className="text-xs font-mono uppercase tracking-widest text-muted-foreground block mb-4">
            05 / HVAD I FÅR
          </span>
          <h2 className="text-4xl md:text-6xl text-foreground tracking-tight font-serif font-light mb-4">
            Hvad får I ud af det?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits?.map((benefit, i) => (
            <div
              key={i}
              className={`p-8 border border-border rounded-xl bg-card hover:border-primary/30 transition-colors reveal delay-${(i + 1) * 100}`}
            >
              <div className="text-4xl mb-6">{benefit?.icon}</div>
              <h3 className="text-xl text-foreground font-medium mb-3">{benefit?.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{benefit?.desc}</p>
            </div>
          ))}
        </div>

        {/* Value Statement */}
        <div className="mt-16 p-10 border border-primary/20 rounded-xl bg-primary/5 text-center reveal delay-300">
          <p className="text-2xl md:text-3xl text-foreground font-serif font-light mb-4">
            Fra dokument til data – automatisk
          </p>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Spar tid, reducer fejl og få fuldt overblik over dine dokumentflows på tværs af systemer.
          </p>
        </div>
      </div>
    </section>
  );
}
